import {Component, Input, OnDestroy, OnInit} from '@angular/core';
import {Router, RouterService} from "../../../../../../services/back/router.service";
import {Subscription, tap} from "rxjs";
import {RouterDetailData, RouterDetailService} from "../../../../../../services/front/router-detail.service";
import {NgIf} from "@angular/common";
import {TranslateModule} from "@ngx-translate/core";
import {RouterInformationFormComponent} from "./router-information-form/router-information-form.component";
import {RouterNetworksComponent} from "./router-networks/router-networks.component";
import {RouterInternetConnectionComponent} from "./router-internet-connection/router-internet-connection.component";
import {NetworkInterface} from "../../../../../../services/back/network.service";
import {DashboardPageLoaderComponent} from "../../../../../global/title-content-loader/dashboard-page-loader.component";

@Component({
  selector: 'app-router-overview-tab',
  standalone: true,
	imports: [
		NgIf,
		TranslateModule,
		RouterInformationFormComponent,
		RouterNetworksComponent,
		RouterInternetConnectionComponent,
		DashboardPageLoaderComponent
	],
  templateUrl: './router-overview-tab.component.html',
  styleUrl: './router-overview-tab.component.scss'
})
export class RouterOverviewTabComponent implements OnInit, OnDestroy{
	@Input() tabActive: boolean;

	tenantId: string;
	isEditor: boolean;
	isTenantInactivePlan: boolean;

	router: Router;

	networks: NetworkInterface[] = [];

	_initializing: boolean;
	initialized: boolean = false;

	subscription: Subscription = new Subscription();

	constructor(private routerDetailService: RouterDetailService,
				private routerService: RouterService) {
	}

	ngOnInit() {
		this.subscription.add(this.routerDetailService.getInitializingChanges()
			.subscribe(initializing => this._initializing = initializing));
		this.subscription.add(this.routerDetailService.getRouterDetailDataChanges()
			.pipe(tap(data => this.setRouterDetailData(data)))
			.subscribe(() => this.initialize()));
	}

	initialize(): void {
		this.subscription.add(this.routerService.getRouterNetworks(this.tenantId, this.router.id)
			.pipe(
				tap((data) => this.setData(data))
			).subscribe(() => this.initialized = true));
	}

	private setData(data: NetworkInterface[]): void {
		this.networks = data;
	}

	private setRouterDetailData(data: RouterDetailData): void {
		this.tenantId = data.tenantId;
		this.isEditor = data.isEditor;
		this.router = data.router;
		this.isTenantInactivePlan = data.isInactivePlan;
	}

	ngOnDestroy() {
		this.subscription.unsubscribe();
	}
}
